import { useLayoutEffect } from 'react';
import { WordsetContextProvider } from '@/contexts/WordSetContext/entry';
import { SetsSelectedWrapper } from './SetsSelectedWrapper';
import { StackScreenProps } from '@react-navigation/stack';
import { SetEditorFlow } from '@/contexts/SetEditorContext';
import { TherapistStackParamList } from '@/navigations/TherapistStack';

const TITLE: Partial<Record<SetEditorFlow, string>> = {
  createSet: 'Wörterset erstellen',
  createTemplate: 'Vorlage erstellen',
  templateFromSet: 'Vorlage erstellen',
  editTemplate: 'Vorlage bearbeiten',
  duplicateTemplate: 'Vorlage duplizieren',
};

export default function WordSet(
  props: StackScreenProps<TherapistStackParamList, 'WordSet'>,
) {
  const { flow } = props.route.params;

  useLayoutEffect(() => {
    const title = TITLE[flow];
    if (!title) {
      return;
    }
    props.navigation.setOptions({
      title,
      headerTitleAllowFontScaling: false,
    });
  }, [props.navigation, flow]);

  return (
    <WordsetContextProvider
      setId={props.route?.params?.setId}
      patientId={props.route?.params?.selectedID}
      apiName={props.route?.params?.apiName}
      fromTemplate={props.route?.params?.fromTemplate}
    >
      <SetsSelectedWrapper props={props} />
    </WordsetContextProvider>
  );
}
